import React from 'react';
import ContentConstants from '../../../../contentConstants';
import { FormattedDraggableHeaderRow, FormattedDraggableTh } from '../FormattedDesignTable';

export interface DraggableHeaderRowProps {
	pageFlowElementsExist: boolean;
	expanded: boolean;
	randomized: boolean;
	showLastHeader: boolean;
}

export const DraggableHeaderRow = (props: DraggableHeaderRowProps) => {
	const { pageFlowElementsExist, expanded, randomized, showLastHeader } = props;

	return (
		<FormattedDraggableHeaderRow pageFlowElementsExist={pageFlowElementsExist}>
			<FormattedDraggableTh flexBasis={0} />
			<FormattedDraggableTh flexBasis={expanded ? 50 : 70}>
				{expanded
					? ContentConstants.TABLE_HEADER_DIMENSIONTEXT + ContentConstants.TABLE_HEADER_QUESTIONTEXT
					: ContentConstants.TABLE_HEADER_QUESTIONTEXT}
			</FormattedDraggableTh>
			{(expanded || randomized) && (
				<FormattedDraggableTh flexBasis={25}>{ContentConstants.TABLE_HEADER_RESPONSEOPTION}</FormattedDraggableTh>
			)}
			{expanded && <FormattedDraggableTh flexBasis={15}>{ContentConstants.TABLE_HEADER_HIDE_QUESTION}</FormattedDraggableTh>}
			<FormattedDraggableTh flexBasis={10}>{ContentConstants.TABLE_HEADER_FOLLOWUP_QUESTION}</FormattedDraggableTh>
			<FormattedDraggableTh flexBasis={10}>{ContentConstants.TABLE_HEADER_QUESTION_LOGIC}</FormattedDraggableTh>
			{showLastHeader && <FormattedDraggableTh flexBasis={0} />}
		</FormattedDraggableHeaderRow>
	);
};
